/**
 * @file 百度地图 ua校验
 * @author wangjuntao <wangjuntao@baidu.com>
 */
/**
 * 判断当前浏览器是否为百度地图
 *
 * @return {boolean} 判断当前浏览器是否为百度地图
 */
export default function is() {
    return /baidumap/i.test(navigator.userAgent);
}
//# sourceMappingURL=is.js.map